<template>
    <div class="close-icon" @click="handleClickEvent">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 96 96" xml:space="preserve">
            <polygon points="96,14 82,0 48,34 14,0 0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48 "/>
        </svg>
    </div>
</template>

<script>
    export default {
        props: {
            //
        },
        components: {
            //
        },
        mixins: [
            //
        ],
        data() {
            return {
                loaded: false,
            }
        },
        mounted() {
            this.loaded = true
        },
        methods: {
            /**
             * Handles a click event on the component root
             *
             * @param  {Object} event
             * @return {void}
             */
            handleClickEvent (event) {
                this.$emit('click', event)
            },
        },
        computed: {
            //
        }
    }
</script>

<style lang="less">
.close-icon {
    cursor: pointer;

    svg polygon {
        transition: fill 0.15s ease;
        fill: #888888;
    }

    &:hover {
        svg polygon {
            fill: #222222;
        }
    }
}
</style>
